<div class="session-warning-snackbar">
  <div>
    <div>{{ 'session.warning.message' | translate }}</div>
    <div>{{ 'session.warning.countdown' | translate:{ time: countdownLabel } }}</div>
  </div>
  <button matButton type="button" (click)="staySignedIn()">
    {{ 'session.warning.action' | translate }}
  </button>
</div>
